module.exports = __webpack_public_path__ + "img/Dantam Hair 14.f8c37e31.jpg";